"use client";

import * as React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Progress } from "@/components/ui/progress";
const galleryItems = [{
  id: 1,
  title: "Kleur & Styling door Emma",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/before_after_01.png"
}, {
  id: 2,
  title: "Complete Make-over door Emma",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/before_after_02.png"
}, {
  id: 3,
  title: "Highlights & Gloss door Emma",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/before_after_03.png"
}, {
  id: 4,
  title: "Volume Behandeling door Emma",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/before_after_04.png"
}, {
  id: 5,
  title: "Knippen & Modelleren door Emma",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/before_after_05.png"
}, {
  id: 6,
  title: "Herensnit Transformatie door Emma",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/before_after_06.png"
}];
export default function InspirationGallery() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  const progressValue = count === 0 ? 0 : current / count * 100;
  return <section data-section-id="75423" id="voor-na-resultaten" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8 mb-12">
        <span className="text-primary font-sans text-sm uppercase tracking-widest mb-3 block">
          TRANSFORMATIES
        </span>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-7xl text-secondary font-bold">
          Voor & Na
        </h2>
      </div>

      {}
      <div className="pl-4 md:pl-8 lg:pl-[calc((100vw-80rem)/2+2rem)] 2xl:pl-[calc((100vw-80rem)/2+2rem)]">
        <Carousel opts={{
        align: "start",
        loop: true
      }} setApi={setApi} className="w-full">
          <CarouselContent className="-ml-4 md:-ml-6">
            {galleryItems.map((item, i) => <CarouselItem key={item.id} data-index={i} className="pl-4 md:pl-6 basis-[85%] sm:basis-1/2 md:basis-1/3 lg:basis-1/4">
                <div className="group relative overflow-hidden rounded-xl bg-muted shadow-sm">
                  <AspectRatio ratio={4 / 5}>
                    <img src={item.image} alt={item.title} className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-105" />
                    <div className="absolute inset-0 bg-secondary/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center p-6">
                      <h3 className="text-white font-serif text-2xl md:text-3xl text-center translate-y-4 group-hover:translate-y-0 transition-transform duration-500 ease-out">
                        {item.title}
                      </h3>
                    </div>
                  </AspectRatio>
                </div>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12 flex flex-col sm:flex-row items-center gap-8">
        <div className="w-full sm:flex-1 order-2 sm:order-1">
          <Progress value={progressValue} className="h-1 bg-border [&>div]:bg-primary" />
        </div>
        
        <div className="flex gap-4 order-1 sm:order-2 self-end sm:self-auto">
          <Button variant="outline" size="icon" className="rounded-full border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300" onClick={() => api?.scrollPrev()} aria-label="Vorige afbeelding">
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <Button variant="outline" size="icon" className="rounded-full border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300" onClick={() => api?.scrollNext()} aria-label="Volgende afbeelding">
            <ArrowRight className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>;
}